import React from "react";
import * as d from "shared/src/date.mjs";
import IconCake from "../icons/IconCake";
import { Tooltip } from "@mui/material";

const specialDay = {
  NAME_DAY: "NAME_DAY",
  BIRTHDAY: "BIRTHDAY",
};

const specialDayTitle = {
  [specialDay.NAME_DAY]: "svátek",
  [specialDay.BIRTHDAY]: "narozeniny",
};

/**
 * @param {object} client
 * @param {string} client.birthdate
 * @param {Set<string>} nameDayNames
 */
function getSpecialDay(client, nameDayNames) {
  if (client.birthdate != null) {
    const now = new Date();
    const birthdate = d.parseDateTime(client.birthdate);

    if (
      now.getMonth() === birthdate.getMonth() &&
      now.getDate() === birthdate.getDate()
    ) {
      return specialDay.BIRTHDAY;
    }
  }

  if (nameDayNames.has(client.first_name)) {
    return specialDay.NAME_DAY;
  }
}

/**
 * @param {object} props
 * @param {object} props.client
 * @param {string} props.client.birthdate
 * @param {Set<string>} props.nameDayNames
 */
export default function SpecialDay({ client, nameDayNames, iconProps }) {
  const specialDay = getSpecialDay(client, nameDayNames);

  return specialDay == null ? null : (
    <Tooltip title={specialDayTitle[specialDay]}>
      <IconCake {...iconProps} />
    </Tooltip>
  );
}
